/**
 * @generated SignedSource<<19a88c6b974e5c738c8abd11467b9d4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceIndustries_productizedService$data = {
  readonly industryCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProductizedServiceIndustries_productizedService";
};
export type ProductizedServiceIndustries_productizedService$key = {
  readonly " $data"?: ProductizedServiceIndustries_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceIndustries_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceIndustries_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IndustryCategoryConnection",
      "kind": "LinkedField",
      "name": "industryCategories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IndustryCategoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IndustryCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "223aaf75bda7ff7e037e40967d82650e";

export default node;
